/**
 * AvisoVersionNueva -- el aviso discreto de "hay una version nueva del panel" (PANEL-VERSION-NUEVA-T1).
 *
 * AUDIENCIA: cualquiera con el panel autenticado abierto (dueno, admin), escritorio o celular. Se
 * monta desde showApp(); la ficha publica del onboarding entra por showPublic() y NO lo monta
 * (limite del ASSIGN #17224: ahi el aviso tapaba el campo en el celular).
 *
 * Reusa el estilo del toast que ya existia (#nx-sw-toast, base.css). Nunca recarga solo: el boton
 * Recargar lo hace quien mira, cuando quiere. "Luego" lo esconde por esta sesion.
 *
 * Consulta /version.json como mucho cada 5 minutos: a intervalos y al volver a la pestana, con el
 * mismo freno para los dos (regla en application/version/versionNueva.js).
 *
 * @module presentation/components/AvisoVersionNueva
 */

import { crearVigia, CADA_MS } from '../../application/version/versionNueva.js';

/* global __APP_COMMIT__, __APP_VERSION__ */
const CORRIENDO = {
  commit: typeof __APP_COMMIT__ !== 'undefined' ? __APP_COMMIT__ : 'local',
  version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : ''
};

let iniciado = false;

async function leerVersionServida() {
  const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
  if (!res.ok) return null;
  return res.json();
}

function mostrarAviso(servida) {
  if (document.getElementById('nx-sw-toast')) return;
  const toast = document.createElement('div');
  toast.id = 'nx-sw-toast';
  toast.setAttribute('data-version-nueva', String(servida?.commit || ''));
  toast.setAttribute('role', 'status');
  toast.innerHTML = `
    <span>Hay una versión nueva del panel${servida?.version ? ` (${String(servida.version).replace(/[<>&"]/g, '')})` : ''}</span>
    <button id="nx-version-recargar">Recargar</button>
    <button id="nx-version-luego" title="Recordármelo luego">Luego</button>`;
  document.body.appendChild(toast);
  document.getElementById('nx-version-recargar').onclick = () => window.location.reload();
  document.getElementById('nx-version-luego').onclick = () => toast.remove();
}

/**
 * FRONT-OBSTRUCCIONES-T1: el aviso de version (#nx-sw-toast) no flota: va como franja en el flujo, justo debajo de la
 * barra superior, y empuja el contenido en vez de taparlo (medido 2.2.636: tapaba tarjetas del kiosco, del inicio y
 * acciones del armador). Lo crean dos lugares (index.html por el service worker, y este modulo), los dos al final del
 * body; aqui se lo reubica en cuanto aparece, sin tocar a quien lo crea.
 */
export function ubicarAvisoVersion() {
  const mover = () => {
    const toast = document.getElementById('nx-sw-toast');
    if (!toast || toast.dataset.ubicado === '1') return;
    const nav = document.getElementById('nx-nav');
    if (nav && nav.parentElement) nav.after(toast); else document.body.prepend(toast);
    toast.dataset.ubicado = '1';
    // Las vistas de pantalla completa (el kiosco es una capa fija) ponen la franja arriba y arrancan debajo de su alto.
    const alto = () => document.documentElement.style.setProperty('--nx-aviso-alto', Math.ceil(toast.getBoundingClientRect().height) + 'px');
    alto();
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(alto).observe(toast);
  };
  mover();
  new MutationObserver(mover).observe(document.body, { childList: true });
}

/** Arranca el vigia una sola vez por pestana. */
export function iniciarAvisoVersionNueva() {
  if (iniciado) return;
  iniciado = true;
  ubicarAvisoVersion();
  const vigia = crearVigia({ corriendo: CORRIENDO, leer: leerVersionServida, alAviso: mostrarAviso });
  setInterval(() => { vigia.revisar(); }, CADA_MS);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') vigia.revisar();
  });
  // La primera, un rato despues de entrar: no compite con la carga de la pantalla.
  setTimeout(() => { vigia.revisar(); }, 30 * 1000);
}
